<template>
  <div>
    <div class="container" v-loading.fullscreen.lock="fullscreenLoading">
      <el-row style="margin-bottom:10px">
        <el-col :span="2">
          <el-date-picker v-model="value"
                          size="mini"
                          type="year"
                          placeholder="选择年">
          </el-date-picker>
        </el-col>
        <el-col :span="20"
                style="justify-content:flex-end">
          <el-button type="primary"
                     @click="update"
                     v-if="show($store.state.menuList.dfzdlist,'import')"
                     size="mini">上传</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-table border
                  ref="multipleTable"
                  :data="tableData.slice((current-1)*10,current*10)"
                  @selection-change="handleSelectionChange"
                  tooltip-effect="dark"
                  style="width: 100%">
          <el-table-column type="selection"
                           width="100">
          </el-table-column>
          <el-table-column label="月份"
                           sortable
                           props="month">
          </el-table-column>
          <el-table-column prop="fileName"
                           label="文件名">
          </el-table-column>
          <el-table-column prop="fileDesc"
                           label="描述">
          </el-table-column>
          <el-table-column prop="opUser"
                           label="上传用户">
          </el-table-column>
          <el-table-column prop="updateTime"
                           label="更新时间">
          </el-table-column>
          <el-table-column prop="address"
                           label="操作"
                           width="200"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text"
                         size="small"
                         v-if="show($store.state.menuList.dfzdlist,'delete')"
                         @click="deleteTable(scope.$index, tableData,scope.row.billId)">删除</el-button>
              <el-button type="text"
                         size="small"
                         v-if="show($store.state.menuList.dfzdlist,'export')"><a @click="exportMethod('https://c.cesc-energy.com/service/clientBill/download/'+scope.row.billId,scope.row.fileName)">下载</a></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <el-checkbox v-model="checked"
                       @change="toggleAllSelection"
                       style="margin-right:20px">全选</el-checkbox>
          <el-button @click="deleteTables"
                     v-if="show($store.state.menuList.dfzdlist,'deletes')"
                     type="danger">批量删除</el-button>
        </div>
      </el-row>
    </div>
    <el-dialog title="上传电费账单"
               style="width:1000px;margin:auto"
               :visible.sync="dialogFormVisible">
      <el-form :model="form"
               ref="form"
               label-width="80px">
        <el-form-item label="账单日期"
                      required>
          <el-date-picker v-model="form.date"
                          size="mini"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.fileDesc"
                    type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="选择文件">
          <el-upload class="upload-demo"
                     action
                     :http-request="uploadfile">
            <el-button size="small"
                       type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <div style="text-align:center">
            <el-button @click="dialogFormVisible=false"
                       style="margin-right:60px">取消</el-button>
            <el-button @click="onsubmitForm('form')"
                       type="primary">保存</el-button>
          </div>

        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getClientBill, postClientBill, deleteClientBill, getmenusubmenu, deletesClientBill, uploadClientBill, downClientBill } from '../../API'
import { parantId } from '../../util/parantId'
import { show } from '../../util/show'
import exportMethod from '../../util/util'
export default {
  data () {
    return {
      tableData: [],
      checked: false,
      value: '',
      dialogFormVisible: false,
      total: '',
      current: 1,
      multipleSelection: [],
      form: {
        date: '',
        fileDesc: '',
        filepath: '',
        fileName: '',
        updateTime: ''
      },
      fullscreenLoading:false
    }
  },
  computed: {
    menuList () {
      return this.$store.state.menuList.dfzdlist
    }
  },
  created () {
    getClientBill(localStorage.getItem('id')).then(res => {
      if (res.code == 0) {
        this.tableData = res.data
        this.total = res.data.length
      }
    })
    parantId(this.$store.state.permissionList.data, this.$route.path, this.$store)
    if (this.$store.state.parantId.parantId) {
      getmenusubmenu(this.$store.state.parantId.parantId).then(res => {
        if (res.code === 0) {
          this.$store.commit('menuList/COMMIT_DATA', { name: 'dfzdlist', data: res.data })
        }
      })
    }

  },
  watch: {
    "$store.state.parantId.parantId" (newval, olval) {
      getmenusubmenu(newval).then(res => {
        if (res.code === 0) {
          this.$store.commit('menuList/COMMIT_DATA', { name: 'dfzdlist', data: res.data })
        }
      })
    },
  },
  methods: {
    exportMethod,
    show,
    down (id) {
      downClientBill(id)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    uploadfile (item) {
      this.fullscreenLoading=true
      let fileObj = item.file
      const form = new FormData()// FormData 对象
      form.append('attach', fileObj)// 文件对象  'upload'是后台接收的参数名
      uploadClientBill(form).then(res => {
        if (res.code == 0) {
          this.fullscreenLoading=false
          this.form.filepath = res.data.filepath
          this.form.fileName = res.data.fileName
          this.form.fileType = res.data.fileType
          this.form.userId = res.data.userId
          this.form.userName = res.data.userName
          this.form.updateTime = res.data.updateTime
        }
        else{
          this.fullscreenLoading=false
        }
      })
    },
    onsubmitForm () {
      let params = {
        clientId: localStorage.getItem('id'),
        fileDesc: this.form.fileDesc,
        fileName: this.form.fileName,
        filepath: this.form.filepath,
        fileType: this.form.fileType,
        userName: this.form.userName,
        userId: this.form.userId,
        month: new Date(this.form.date).getMonth() + 1,
        opUser: localStorage.getItem('user') || 0,
        opUserId: localStorage.getItem('userId') || 0,
        updateTime: this.form.updateTime,
        year: new Date(this.form.date).getFullYear(),
      }
      postClientBill(params).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '上传成功',
            type: 'success'
          });
          this.dialogFormVisible = false
          getClientBill(localStorage.getItem('id')).then(res => {
            if (res.code == 0) {
              this.tableData = res.data
              this.total = res.data.length
            }
          })
        }
      })
    },
    toggleAllSelection () {
      this.$refs.multipleTable.toggleAllSelection()
    },
    deleteTable (index, rows, id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        deleteClientBill(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.current = 1,
              getClientBill(localStorage.getItem('id')).then(res => {
                if (res.code == 0) {
                  this.tableData = res.data
                  this.total = res.data.length
                }
              })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteTables () {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          params.push(this.multipleSelection[i].billId)
        }
        deletesClientBill(params).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.current = 1,
              getClientBill(localStorage.getItem('id')).then(res => {
                if (res.code == 0) {
                  this.tableData = res.data
                  this.total = res.data.length
                }
              })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    update () {
      this.dialogFormVisible = true
    },
    handleClick (row) {
      console.log(row);
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
  border: none;
  background-color: #fff;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}

/deep/ .el-table th.is-leaf {
  background-color: rgb(249, 250, 252);
}
.el-col {
  height: 40px;
  align-content: center;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666666;
}
</style>